module.exports = __webpack_public_path__ + "static/media/16UNODC26.db3b000a.jpg";